export const isEmbedded = (w = window) => (
  w.parent.location !== w.location
)

export const isProdAdminEmbedded = (w = window) => {
  const proadmin_hosts = [
    'prodadmin.myxplor.com',
    'staging-admin.myxplor.com',
    'web.myxplor.com',
    'staging-web.myxplor.com'
  ]
  const parent_host = w.document.referrer ? new URL(w.document.referrer).host : ''

  return proadmin_hosts.includes(parent_host)
}



// WEBPACK FOOTER //
// ./src/embedded/detection/index.js